<template>
    <div id="listInsurancePolicy">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Insurance Policy List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a v-if="hideButton === false" href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canAddInsurancePolicy && hideButton === false" class="btn btn-primary" v-bind:to="{name: 'InsurancePolicyCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content insurance-policy-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'insurancePolicyList'" @cancelSelection="cancelAll" :fromDashboard="$route.query.from" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'insurancePolicyList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listInsurancePolicyTable"
                                      mode="remote"
                                      @on-page-change="onPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      :totalRows="totalRecords"
                                      @on-select-all="onSelectAll"
                                      title="Insurance Policy"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :paginate="true"
                                      :paginationOptions="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: insurance_policy_value,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                          enabled: false,
                                      }"
                                  >

                                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                      <div :key="key">
                                          <div v-if="props.column.field == 'action'">
                                              <template v-if="canUpdateInsurancePolicy">
                                                  <router-link title="Edit Insurance Policy" class="fp-edit" v-bind:to="{name: 'InsurancePolicyEdit',params:{id:props.row.id}}"></router-link>
                                              </template>
                                          </div>
                                          <div v-else-if="props.column.field == 'company'">
                                              <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                          </div>
                                          <div v-else-if="props.column.field == 'policy_number'">
                                                  <template v-if="canViewInsurancePolicy">
                                                      <router-link title="View Policy" class="color-blue" v-bind:to="{name: 'InsurancePolicyView',params:{id:props.row.id}}">{{props.row.policy_number}}</router-link>
                                                  </template>
                                              </div>
                                          <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                          </div>
                                      </div>
                                  </template>

                                  <div slot="selected-row-actions">
                                      <button v-if="insurance_policy_value" id="deleteInsurancePolicyBtn" v-on:click.prevent="insurancePolicyDelete()" class="btn btn-primary">Delete</button>
                                  </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                        <div class="modal fade agreement-policy-modal" id="agreement-policy-modal" ref="agreementPolicyModal" data-backdrop="true" data-keyboard="false" aria-labelledby="seperateMessageModal" aria-hidden="true">
                                    <div class="modal-dialog modal-lg" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Message</h5>
                                                <button type="button" class="close" id="btnModalMessageClose" v-on:click="hideMessageModal()">&times;</button>
                                            </div>
                                            <div class="modal-body">
                                                <p>Following Insurance Policy already Mapped with Rental Agreement : </p>
                                                <template v-if="agreementPolicyArr.length > 0">
                                                    <template v-for="(row,key) in agreementPolicyArr">
                                                        <p :key="key">Policy Number : {{row.policy_number}}&nbsp;&nbsp;</p>
                                                            <template v-if="row.agreement.length > 0">
                                                                <p :key="'agreement'+key">
                                                                Agreement Code:
                                                                <template v-for="(agreement,index) in row.agreement">
                                                                    <a :key="'i' + index" v-if="index > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + index"> {{agreement}}</span>
                                                                </template>
                                                                </p>
                                                            </template>
                                                        <!-- </p> -->
                                                    </template>
                                                </template>
                                            </div>
                                            <div class="modal-footer">
                                            </div>
                                        </div>
                                    </div>
                        </div>
                        <div class="modal fade policy-modal" id="policy-modal" ref="policy-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="policy-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                                    <input id="policyFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_error}}</div>
                                                </div>
                                            </div>
                                        </form>
                                        <template v-if="duplicatePolicy.customer && duplicatePolicy.customer.length > 0">
                                            <p>&nbsp;</p>
                                            <label class="d-block"> Policy Not Imported Because These Customer with Code Not Available:</label>
                                            <template v-for="(policy,customerKey) in duplicatePolicy.customer">
                                                <a :key="customerKey" v-if="customerKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="customerKey">{{policy.customer_number}}</span>
                                            </template>
                                            <p>&nbsp;</p>
                                        </template>
                                        <template v-if="duplicatePolicy.duplicate && duplicatePolicy.duplicate.length > 0">
                                            <p>&nbsp;</p>
                                            <label class="d-block"> Policy Not Imported Because These Policy Number Already Exists:</label>
                                            <template v-for="(duppolicy,dupPolicyKey) in duplicatePolicy.duplicate">
                                                <a :key="dupPolicyKey" v-if="dupPolicyKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="dupPolicyKey">{{duppolicy.policy_number}}</span>
                                            </template>
                                            <p>&nbsp;</p>
                                        </template>
                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButton" v-on:click="importPolicy()"> <i class="fp-import"> </i> Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>

    import EventBus from "../event-bus";
    import Vue from 'vue';

    
    



    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "listUser",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Insurance Policy List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            hideButton:false,
            firstLoad:0,
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Policy Number',
                    field: 'policy_number',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Policy Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },
                {
                    label: 'Policy Type',
                    field: 'policy_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Policy Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Self Insured For',
                    field: 'self_insured_for',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Self Insured For", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Insurance Company',
                    field: 'ins_company',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Insurance Company", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },

                {
                    label: 'Customer Name',
                    field: 'company',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },

                },

                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    fpFieldType:"date",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    fpFieldType:"date",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },
                {
                    label: 'Agent Name',
                    field: 'agent_name',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Agent Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },

                {
                    label: 'Agent Phone',
                    field: 'agent_phone',
                    fpFieldType:"text",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Agent Phone", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }

                },


            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            permissions:[],
            cantAccessPage:"",
            insurance_policy_value:false,
            action:'list',
            canUpdateInsurancePolicy:false,
            canAddInsurancePolicy:false,
            canViewInsurancePolicy:false,
            pageKey:"_insurance_policy_list_",
            agreementPolicyArr:[],
            selectedFile:"",
            import_error:"",
            duplicatePolicy:[],
            batchProcess:0,
            batchNum:"",
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_insurance_policies') {
                        self.cantAccessPage = true;
                    }
                    if (permissions.name == 'delete_insurance_policies') {
                      if(self.$route.query.flag == 'insuranceReport'){

                              self.insurance_policy_value = false;
                            } else{
                              self.insurance_policy_value = true;
                            }

                    }
                    if (permissions.name == 'add_insurance_policies') {
                        self.canAddInsurancePolicy = true;
                        self.canUpdateInsurancePolicy = true;
                    }
                    if (permissions.name == 'view_insurance_policies') {
                        self.canViewInsurancePolicy = true;
                    }

                });
                if(self.cantAccess == ''){
                    self.cantAccessPage = false;
                }
            }
        },
        created: function() {
            //this.serverParams.sort = {field:"start_date",type:"desc"};
        },
        mounted: function () {

            var self = this;
            if(self.$route.query.flag == 'insuranceReport'){
              self.hideButton = true;
               for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }
            }

            // this.loadList();
            this.getPermissions();


        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listInsurancePolicyTable.unselectAllInternal();
            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listInsurancePolicyTable'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },
            loadList: function(){

                var date = new Date();
                var offset = date.getTimezoneOffset();

                var data = this.$refs['listInsurancePolicyTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listInsurancePolicyTable'].selectedRows[i].id)
                }

                var self = this;
                self.loading =  true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/insurance/policy/list",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",

                    data:{
                        offset:offset,
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        sort:self.serverParams.sort,
                        all:self.serverParams.selectedAll,
                        selectedRows:use,
                        action:self.action,
                    },
                    success: function (data) {
                        self.loading =  false;
                        //console.log(data.content[0]["id"]);
                        if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          self.loadList();
                        }else if ( self.action =='delete'){

                            self.action = 'list';
                            if (data.status == "success") {
                                self.agreementPolicyArr = [];
                                if (data.content.agreementPoliciesMapped && data.content.agreementPoliciesMapped.length > 0) {
                                    //agreement policy mapped message
                                    self.agreementPolicyArr = data.content.agreementPoliciesMapped;
                                    $("#agreement-policy-modal").modal("show");
                                }
                            }
                            self.loadList();
                        }else{
                            if (data.status == "success") {
                                self.rows = data.content.row;
                                //
                                // self.perPage = data.content.perPage;
                                self.totalRecords = data.content.totalRecords;
                            }
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading =  false;
                        if ( self.action =='delete') {
                            self.generateStatusCodeMessage(jqXHR, true, 'insurance-policy-list')
                        }else{
                            self.generateStatusCodeMessage(jqXHR, false, 'insurance-policy-list')
                        }
                    }
                });
            },
            insurancePolicyDelete() {
               // var data = this.$refs['listInsurancePolicyTable'].selectedRows;
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Insurance Policy?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = 'delete';
                      self.loadList();
                    } else {
                      console.log("no");
                    }
                });
                // var use = [];
                // for (var i = 0; i < data.length; i++) {
                //     use.push(this.$refs['listInsurancePolicyTable'].selectedRows[i].id)
                // }

                // if (confirm('Are you sure that you want to delete this Insurance Policy? ')) {

                //     self.action = 'delete';
                //     self.loadList();
                    return;
                    // self.loading = true;
                    // $("#deleteInsurancePolicyBtn").val("Deleting ...");
                    // $.ajax({
                    //     url: process.env.ROOT_API + "/insurancepolicy/delete",
                    //     type: "POST",
                    //     data: 'id=' + use,
                    //     headers: this.ajxHeaders,
                    //     dataType: 'json',
                    //     success: function (data) {
                    //         self.loading = false;
                    //         setTimeout(function () {
                    //         $(".alert-success").removeClass("show");
                    //             $(".alert-success").addClass("hide");
                    //         }, 10000);
                    //         setTimeout(function () {
                    //             $("#deleteInsurancePolicyBtn").val("Delete");
                    //         }, 10000);
                    //         if (data.code == '200') {
                    //             self.loadList();
                    //         }
                    //     },
                    //     error: function (jqXHR, exception) {
                    //         self.loading = false;
                    //         self.generateStatusCodeMessage(jqXHR,true,'insurance-policy-delete')
                    //     }
                    // });
               // }
            },
            hideMessageModal() {
                var self = this;
                $("#agreement-policy-modal").modal("hide");
                self.agreementPolicyArr = [];
            },
            openModal: function(){
                var self = this;
                self.selectedFile = "";
                self.duplicatePolicy = [];
                $("#policyFile").val('');
                self.import_error = '';
                $('#policy-modal').modal('show');
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                var self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            importPolicy() {
                var self = this;
                self.import_error = "";
                if(self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/insurancepolicy/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_error = '';
                        if (data.code == 201) {
                            self.import_error = data.message;
                            return;
                        }
                        if (data.status == "success") {

                            if ( Object.keys(data.duplicate).length > 0){

                                self.duplicatePolicy = data.duplicate;

                            }else{
                                if(data.content != false){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                self.import_error = "";
                                $('#policy-modal').modal('hide');
                            }
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'policy-import-error')
                    }
                });
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/insurance/InsurancePolicyList.vue